<template>
  <MfpPopup />
  <EdreaPopup />
  <AboutPopup />
  <PreloaderComponent />
  <div
    class="edrea_tm_all_wrap"
    data-magic-cursor="show"
    data-enter="fadeInUp"
    data-exit=""
  >
    <!-- WAVE DOTS -->
    <div class="waves"></div>
    <!-- WAVE DOTS -->

    <!-- HEADER -->
    <HeaderComponent />
    <!-- /HEADER -->

    <!-- CONTENT -->
    <div class="edrea_tm_content">
      <!-- HOME -->
      <HomeComponent />
      <!-- /HOME -->

      <!-- SERVICES -->
      <ServicesComponent />
      <!-- /SERVICES -->

      <!-- PROJECTS -->
      <ProjectsComponent />
      <!-- /PROJECTS -->

      <!-- CONTACT -->
      <ContactComponent />
      <!-- /CONTACT -->
    </div>
    <!-- /CONTENT -->

    <!-- FOOTER -->
    <FooterComponent />
    <!-- /FOOTER -->

    <!-- SOFIA CHAT -->
    <SofiaChat />
    <!-- /SOFIA CHAT -->

    <!-- MAGIC CURSOR -->
    <CursorComponent />
    <!-- /MAGIC CURSOR -->
  </div>
</template>

<script>
import PreloaderComponent from "@/components/layout/PreloaderComponent.vue";

import AboutPopup from "@/components/popup/AboutPopup.vue";
import EdreaPopup from "@/components/popup/EdreaPopup.vue";
import MfpPopup from "@/components/popup/MfpPopup.vue";
import ContactComponent from "../components/ContactComponent.vue";
import HomeComponent from "../components/HomeComponent.vue";
import ServicesComponent from "../components/ServicesComponent.vue";
import ProjectsComponent from "../components/ProjectsComponent.vue";
import SofiaChat from "../components/SofiaChat.vue";
import CursorComponent from "../components/layout/CursorComponent.vue";
import HeaderComponent from "../components/layout/HeaderComponent.vue";
import FooterComponent from "../components/layout/FooterComponent.vue";

import { dataImage, imgToSVG } from "../utilits";
import { waves } from "../waves";

export default {
  name: `HomeView`,
  mounted() {
    waves();
    imgToSVG();
    dataImage();
  },
  components: {
    HomeComponent,
    ServicesComponent,
    ProjectsComponent,
    SofiaChat,

    ContactComponent,
    HeaderComponent,
    FooterComponent,
    CursorComponent,
    PreloaderComponent,
    MfpPopup,
    EdreaPopup,
    AboutPopup,
  },
};
</script>

<style>
/* ===== PALETA DE MARCA DATAMIND — TEMA CLARO (tomada del logo) ===== */
:root,
html {
  --main-color: #2176ff !important; /* Azul brillante (MIND) */
  --dm-blue: #2176ff;
  --dm-blue-dark: #1558c9;
  --dm-blue-soft: rgba(33, 118, 255, 0.1);
  --dm-navy: #0d1b3a; /* Azul marino profundo (DATA) */
  --dm-text: #4a5878; /* Texto de párrafo */
  --dm-bg: #ffffff; /* Fondo del sitio */
  --dm-surface: #f5f8fd; /* Superficie de tarjetas */
  --dm-border: #e2eaf6;
}

body {
  background-color: var(--dm-bg) !important;
  color: var(--dm-text) !important;
}

/* Titulares en azul marino */
h1,
h2,
h3,
h4,
h5,
h6,
.edrea_tm_main_title h3,
.edrea_tm_home .name {
  color: var(--dm-navy) !important;
}
.coloring {
  color: var(--main-color) !important;
}
.edrea_tm_home .job,
.edrea_tm_home .job b {
  color: var(--dm-text) !important;
}
.edrea_tm_home .job b {
  color: var(--dm-navy) !important;
  font-weight: 700;
}

/* PROYECTOS: banda gris a todo el ancho para separarlo visualmente del resto.
   El contenido vive en un contenedor del 90%, así que el fondo se pinta con un
   pseudo-elemento que rompe ese ancho y se extiende a los 100vw de la pantalla. */
#projects::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  background: var(--dm-surface);
  border-top: 1px solid var(--dm-border);
  border-bottom: 1px solid var(--dm-border);
  z-index: -1;
}
/* Un poco más de aire para que la banda gris respire */
#projects {
  padding: 90px 0 !important;
}
@media (max-width: 1040px) {
  #projects {
    padding: 50px 0 !important;
  }
}

/* Cuánto suben las ilustraciones del hero para cubrir también la franja del
   header fijo (margen superior del contenido + padding de la sección). */
#home {
  --hero-top-offset: 150px;
}
@media (max-width: 1040px) {
  #home {
    --hero-top-offset: 120px;
  }
}

/* Separador punteado del título */
.edrea_tm_main_title {
  border-color: var(--dm-border) !important;
}

/* ===== LOGO (versión original: oscuro sobre claro) ===== */
.edrea_tm_header .logo img,
.edrea_tm_topbar .logo img {
  max-width: 190px !important;
  max-height: 190px !important;
  object-fit: contain !important;
  width: auto !important;
}
.edrea_tm_header .logo {
  display: inline-flex;
  align-items: center;
}

/* ===== HEADER: transparente arriba; barra blanca flotante al bajar ===== */
.edrea_tm_header .header_inner {
  transition: all 0.4s ease;
  border: 1px solid transparent;
  border-radius: 16px;
}
.edrea_tm_header.scrolled .header_inner {
  padding: 10px 30px !important;
  margin-top: 18px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-color: var(--dm-border);
  box-shadow: 0 10px 30px rgba(13, 27, 58, 0.08);
}
.edrea_tm_header.scrolled .logo img {
  max-width: 130px !important;
  max-height: 130px !important;
}

/* Menú en azul marino (las ilustraciones del hero son claras) */
.edrea_tm_header .menu ul li a {
  color: var(--dm-navy) !important;
  font-weight: 600;
}
.edrea_tm_header .menu ul li a:hover,
.edrea_tm_header .menu ul li.active a {
  color: var(--main-color) !important;
}

.edrea_tm_header .logo img {
  border-radius: 12px;
  transition: all 0.4s ease;
}

/* Barra superior móvil en claro */
.edrea_tm_topbar {
  background-color: #fff !important;
  border-bottom: 1px solid var(--dm-border);
}
.edrea_tm_topbar .hamburger-inner,
.edrea_tm_topbar .hamburger-inner:after,
.edrea_tm_topbar .hamburger-inner:before {
  background-color: var(--dm-navy) !important;
}
.edrea_tm_mobile_menu {
  background-color: #fff !important;
  border-bottom: 1px solid var(--dm-border);
}
.edrea_tm_mobile_menu ul li a {
  color: var(--dm-navy) !important;
}

/* ===== TARJETAS (servicios y proyectos) en claro ===== */
.services_list li .list_inner,
.projects_list li .list_inner {
  border-color: var(--dm-border) !important;
  background-color: #fff !important;
  box-shadow: 0 4px 16px rgba(13, 27, 58, 0.05) !important;
}
.services_list li .list_inner:hover,
.projects_list li .list_inner:hover {
  border-color: var(--main-color) !important;
  box-shadow: 0 20px 40px rgba(33, 118, 255, 0.15) !important;
}
.services_list li .icon {
  background-color: var(--dm-blue-soft) !important;
}
.services_list li .title h3,
.projects_list li .content .title {
  color: var(--dm-navy) !important;
}
.services_list li .text p,
.projects_list li .content .text {
  color: var(--dm-text) !important;
}
.projects_list li .refs {
  border-top-color: var(--dm-border) !important;
}
.projects_list li .refs_links a {
  color: var(--dm-navy) !important;
  border-color: var(--dm-border) !important;
}
.projects_list li .refs_links a:hover {
  color: #fff !important;
}
.projects_list li .modules_list li {
  color: var(--dm-navy) !important;
  background-color: var(--dm-blue-soft) !important;
  border-color: var(--dm-border) !important;
}

/* ===== CONTACTO en claro ===== */
.edrea_tm_contact .left ul li .list_inner {
  background-color: var(--dm-surface) !important;
  border: 1px solid var(--dm-border);
}
.edrea_tm_contact .left ul li .list_inner span a {
  color: var(--dm-navy) !important;
}
.edrea_tm_contact input,
.edrea_tm_contact textarea {
  background-color: var(--dm-surface) !important;
  border: 1px solid var(--dm-border) !important;
  color: var(--dm-navy) !important;
}
.edrea_tm_contact input::placeholder,
.edrea_tm_contact textarea::placeholder {
  color: #93a1bd !important;
}

/* ===== Textos secundarios, botones, selector de idioma y cursor ===== */
.home_content .desc,
.edrea_tm_main_title .subtitle {
  color: var(--dm-text) !important;
}

.edrea_tm_button a {
  background-color: var(--main-color) !important;
  color: #fff !important;
  box-shadow: 0 8px 20px rgba(33, 118, 255, 0.25);
}
.edrea_tm_button a:hover {
  background-color: var(--dm-blue-dark) !important;
  color: #fff !important;
}
.edrea_tm_button.transparent a {
  background-color: transparent !important;
  color: var(--dm-navy) !important;
  border: 1px solid var(--dm-border) !important;
  box-shadow: none;
}
.edrea_tm_button.transparent a:hover {
  background-color: var(--main-color) !important;
  border-color: var(--main-color) !important;
  color: #fff !important;
}

.lang_switcher a {
  color: var(--dm-text) !important;
}
.lang_switcher a:hover {
  color: var(--dm-navy) !important;
}
.lang_switcher a.active {
  color: var(--main-color) !important;
}
.lang_switcher .sep {
  color: var(--dm-border) !important;
}

/* Cursor mágico visible sobre fondo claro */
.cursor-inner {
  background-color: var(--main-color) !important;
}
.cursor-outer {
  border-color: var(--main-color) !important;
}

/* Preloader en claro */
#preloader {
  background-color: #fff !important;
}

/* Global CSS Overrides for Giant Home & Onepage Scroll */
.edrea_tm_header {
  width: 90% !important;
  max-width: 1400px !important;
  z-index: 50 !important;
  pointer-events: none; /* la banda vacía deja pasar el clic */
}
.edrea_tm_header .logo,
.edrea_tm_header .menu {
  pointer-events: auto; /* logo y menú sí reciben clic */
}
/* El contenido debe quedar por debajo del header para no tapar el menú */
.edrea_tm_content {
  z-index: 1 !important;
}
.edrea_tm_content {
  width: 90% !important;
  max-width: 1400px !important;
  position: relative !important;
  top: auto !important;
  bottom: auto !important;
  left: 0 !important;
  transform: none !important;
  margin: 100px auto 0 auto !important;
}

html {
  scroll-behavior: smooth;
}

.edrea_tm_section {
  position: relative !important;
  opacity: 1 !important;
  visibility: visible !important;
  height: auto !important;
  min-height: 100vh !important;
  overflow: visible !important;
  padding: 50px 0 !important;
  scroll-margin-top: 110px !important;
}

.edrea_tm_section.hidden {
  opacity: 1 !important;
  visibility: visible !important;
  z-index: 10 !important;
  display: block !important;
}

/* Servicios y Proyectos: el contenedor debe ser bloque a todo el ancho
   (el template lo pone como flex en fila y rompe la grid de tarjetas) */
#services .section_inner,
#projects .section_inner {
  display: block !important;
  align-items: stretch !important;
  width: 100% !important;
}
#services .edrea_tm_services,
#projects .edrea_tm_projects,
#services .services_list,
#projects .projects_list {
  width: 100% !important;
  flex: 1 1 100% !important;
}
/* Forzar 3 columnas en escritorio para la grid de tarjetas */
#services .services_list,
#projects .projects_list {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 30px !important;
  margin: 50px 0 0 0 !important;
  padding: 0 !important;
}
@media (max-width: 1040px) {
  #services .services_list,
  #projects .projects_list {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: 768px) {
  #services .services_list,
  #projects .projects_list {
    grid-template-columns: 1fr !important;
  }
}

/* En móvil/tablet las secciones se ajustan al contenido (no 100vh forzado) */
@media (max-width: 1040px) {
  .edrea_tm_section {
    min-height: auto !important;
    padding: 30px 0 !important;
  }
  .edrea_tm_content {
    margin-top: 90px !important;
  }
}
</style>
